import axios from 'axios';
import { API_VERSION } from '../config/app';
import { getServerConfig, type RegionEnum } from '../config/region';
import type { TotalUnread } from '../containers/ChatsList/chatListSlice/types';

const ALARM_REQUEST_TIMEOUT_MS = 8000;

export type SessionIndicators = {
  hasActiveAlarm: boolean;
  hasUnreadMessages: boolean;
  hasActiveImOk: boolean;
};

/**
 * Fetches `/api/Messages/TotalUnread` for a given region + access token.
 * Bypasses the global axios client because each inactive session has its own
 * bearer/region pair.
 */
export async function fetchSessionIndicators(
  region: RegionEnum,
  accessToken: string
): Promise<SessionIndicators> {
  const baseURL = getServerConfig(region).coreApiUrl;
  const response = await axios.request<TotalUnread>({
    baseURL,
    url: '/api/Messages/TotalUnread',
    method: 'GET',
    timeout: ALARM_REQUEST_TIMEOUT_MS,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'cosafe-api-version': API_VERSION,
    },
  });

  return {
    hasActiveAlarm: response.data?.ActiveEmergency === true,
    hasUnreadMessages: (response.data?.UnreadMessagesAndRepliesCount ?? 0) > 0,
    hasActiveImOk: (response.data?.activeMusterCount ?? 0) > 0,
  };
}
